import { TOKEN_KEY } from '../constants/constants';
export default (function () {
    return localStorage.getItem(TOKEN_KEY) || null;
});
//# sourceMappingURL=getToken.js.map